module.exports = __webpack_public_path__ + "img/academy.b81409e2.png";